import parseWithDate from 'json.date-extensions'
import React, { Component } from 'react'
import { Table, Message, Header, Label } from 'semantic-ui-react'

//TODO: bessere tabelle machen: https://blog.kulturbanause.de/2012/06/tabellen-im-responsive-webdesign/https://blog.kulturbanause.de/2012/06/tabellen-im-responsive-webdesign/
class SimpleEntryTable extends Component {
state={
  entries:[],
  sumOfEntries:0,
  numberOfEntries:0
}
  formatValue(val)
  {
    const formattedNumber=new Intl.NumberFormat(undefined,{ 
      style: 'decimal', 
      useGrouping:true,
      minimumFractionDigits: 2, 
      maximumFractionDigits: 2 
    }).format(val);
    if(val>0)
      return (
        <Label basic color="green">{formattedNumber}</Label>
      )
    else
      return formattedNumber;

  }

  render() {
    if(!this.props.data){
      return(
        <div>
          <Message error>Fehler aufgetreten, keine Verbindung.</Message>
        </div>
        )
    }
    const entries = JSON.parseWithDate(this.props.data);
    if(!entries.length || entries.length == 0)
    return(
    <div>
      <Message info>Noch keine Einträge vorhanden.</Message>
    </div>
    )
    else
    return (
      <div>
         <Header>Empfangene Einträge</Header>
          
      <Table striped unstackable>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell rowSpan="2" textAlign="right">
              Datum
            </Table.HeaderCell>
            <Table.HeaderCell>
              Empfänger
            </Table.HeaderCell>
            <Table.HeaderCell rowSpan="2">
              Kategorie
            </Table.HeaderCell>
            <Table.HeaderCell rowSpan="2" textAlign="right">
              Betrag
            </Table.HeaderCell>
          </Table.Row>
          <Table.Row>
          <Table.HeaderCell>
              Zweck
            </Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>

{ entries.map((entry, index) => (

            <Table.Row key={entry.id} verticalAlign='top'>
              <Table.Cell textAlign="right">{new Intl.DateTimeFormat(undefined,{year:"numeric", month:"2-digit", day:"2-digit"}).format(entry.date)}</Table.Cell>
              <Table.Cell>{entry.recipient}<br />
              {entry.purpose}</Table.Cell>
              <Table.Cell><Label tag>{entry.category}</Label></Table.Cell>
              <Table.Cell textAlign="right">
              {this.formatValue(entry.value)}
</Table.Cell>

            </Table.Row>
        ))}
        </Table.Body>
        <Table.Footer>
      <Table.Row verticalAlign="top">
        <Table.HeaderCell colSpan="2">{this.props.numberOfEntries} Einträge</Table.HeaderCell>
        <Table.HeaderCell />
        <Table.HeaderCell textAlign="right">Summe<br />{this.formatValue(this.props.sumOfEntries)}</Table.HeaderCell>
        
      </Table.Row>
    </Table.Footer>
      </Table>
      </div>
    )
  }
}

export default SimpleEntryTable;